import { IEquipmentActivity } from 'features/inventory/equipments/types';
import { axiosPrivate } from 'shared/api';
import toast from 'shared/utils/toast';
import { BaseService } from 'shared/services/BaseService';

class EquipmentActivityService extends BaseService<IEquipmentActivity> {
  constructor() {
    super('activities');
    this.canDelete = true;
  }

  /**
   * Overriding parent property using arrow function syntax
   * to match the signature of BaseService.
   */
  public override attachFiles = async (
    file: File,
    attachmentName: string,
    entityId: number
  ): Promise<any> => {
    try {
      const formData = new FormData();
      formData.append(attachmentName, file); // Receives 'file' from the component

      const response = await axiosPrivate.post(
        `${this.modulePrefix}/${entityId}/attach-files/`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return response.data;
    } catch (e: any) {
      toast.error(e?.message || "Errore durante l'upload");
      throw e;
    }
  };
}

export const equipmentActivityService = new EquipmentActivityService();
